import { useTLang } from 'intl/intl';

export function useRenderOnlyProductsAndCustomsLang() {
  return {
    products: {
      title: useTLang({ id: 'menuPage.global.products' }),
    },
    customs: {
      title: useTLang({ id: 'menuPage.global.customizations' }),
    },
  };
}
